import GridItem from "../../components/general/GridItem";
import Icon from "../../components/general/Icon";
import RichText from "../../components/general/RichText";

const BabyBjornUspsModule = ({
	label,
	footer,
	babybjorn_usps,
}: Queries.BabyBjornUspsModuleFragment) => (
	<GridItem>
		<div className="bg-pink space-y-6 p-6 lg:space-y-8 lg:p-10">
			<div className="bb-text-label">{label}</div>
			<div className="gap-bb grid md:grid-cols-2 lg:grid-cols-4">
				{babybjorn_usps?.map((usp) => {
					if (!usp?._uid || !usp.icon || !usp.text) return;
					return (
						<div
							key={usp._uid}
							className="flex items-start gap-4 rounded bg-white px-6 py-4"
						>
							<Icon icon={usp.icon} />
							<h5 className="text-gray-4 break-words">{usp.text}</h5>
						</div>
					);
				})}
			</div>
			{footer && (
				<>
					<hr className="border-gray-4/10 h-px" />
					<RichText
						className="bb-text-body [&_*]:!bb-text-body [&_*]:!text-gray-2 [&_a]:!text-gray-4 [&_a]:no-underline"
						content={footer}
					/>
				</>
			)}
		</div>
	</GridItem>
);

export default BabyBjornUspsModule;
